import {venueDoc} from 'Shared/model/venue';
import { z } from 'zod';
import {AccessAreaName} from 'Common/permissions/AccessArea';
import {BackendPageConfig, backendData} from 'Common/BackendPageConfig';
import { ContactPage } from 'Shared/backend/contact/ContactPage';


export const contactParams = z.object({ 
	tab: z.string().optional()
}).strict();	
export type ContactParams = z.infer<typeof contactParams>;

export const contactData = backendData.extend({
	params: contactParams,
	tabs: z.any(),				//XXX any
	venue:venueDoc
}).strict();
export type ContactData = z.infer<typeof contactData>;


export class Contact extends BackendPageConfig<ContactData,ContactParams>
{
	static readonly pageName = 'backend/contact';
	name() { return Contact.pageName; }

	access() { return 'venueFullEditor' as AccessAreaName; }

	defaultSettings()
	{
		return {
			...super.defaultSettings(),
			template: ContactPage
		};
	}

	permissions()
	{
		return ({
			edit: { collection:'venue' },
			photo: { collection:'venue', assetFolder:'Venue-photo'},
			logo: { collection:'venue', assetFolder:'Venue-logo'},
			logoLandscape: { collection:'venue', assetFolder:'Venue-logoLandscape'},
		});
	}
}

